/**
 * @file banner
 * @author 丁聪
 */

import React, { Component } from 'react'
import './index.scss'

class Banner extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() { }

    render() {
        return (
            <div id="banne">
                <div className="good">
                    {/* <div className="text">
                        <div className="child">优中选优的好老师 让孩子爱学敢说</div>
                        <ul className="hot">
                            <li className="kuang">
                                <div className="zero" ></div>
                                <div className="chin">热情</div>
                            </li>
                            <li className="kuang">
                                <div className="zero" ></div>
                                <div className="chin">耐心</div>
                            </li>
                            <li className="kuang">
                                <div className="zero" ></div>
                                <div className="chin">专属</div>
                            </li>
                            <li className="kuang">
                                <div className="zero" ></div>
                                <div className="chin">负责</div>
                            </li>
                        </ul>
                    </div> */}
                </div>
            </div>
        )
    }
}

export default Banner
